import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NoNotificationsFigure } from "../../../assets/icons/MUI/LayoutIcons";

const EmptyNotificationsFigure = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "32px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <NoNotificationsFigure />
      <Typography variant="h5Bold">{t("layout.notifications.noNotifications")}</Typography>
    </Box>
  );
};

export default EmptyNotificationsFigure;
